import * as React from 'jsx-dom'
import { HTMLElementTagNames } from 'jsx-dom'

export type AlertVariant = 'info' | 'warning' | 'error' | 'success'

export interface AlertProps {
	tag?: HTMLElementTagNames
	variant?: AlertVariant
	icon?: string | null
	componentClass?: string | undefined
	textContent: string
}

const variantClass: Record<AlertVariant, string> = {
	info: '[--alert-bg-color:theme(colors.blue.100)] text-blue-700',
	warning: '[--alert-bg-color:theme(colors.yellow.100)] text-yellow-700',
	error: '[--alert-bg-color:theme(colors.red.100)] text-red-700',
	success: '[--alert-bg-color:theme(colors.green.100)] text-green-700'
}

const variantIcon: Record<AlertVariant, string> = {
	info: 'info',
	warning: 'exclamation',
	error: 'close-circle',
	success: 'check-circle'
}

export const Alert = ({
	tag = 'p',
	variant = 'info',
	icon = variantIcon[variant],
	componentClass = undefined,
	textContent
}: AlertProps): HTMLElement => {
	const Tag = `${tag}` as keyof React.JSX.IntrinsicElements

	return (
		<Tag
			class={[
				'relative flex items-baseline gap-1 py-1 px-1.5 rounded-sm bg-[--alert-bg-color]',
				variantClass[variant],
				componentClass
			]}
		>
			{icon !== null ? <i class={[`icon flex-shrink-0 text-icon icon--${icon}`]} aria-hidden="true"></i> : null}
			<span innerHTML={textContent}></span>
		</Tag>
	) as HTMLElement
}
